export default __webpack_public_path__ + "static/media/logo-ysb.41855f27.png";